import { basicNumberComparator } from "utils/comparatorUtils.js";
import { TAGLIST_TABLE_COLUMNS } from "constants/constantStrings";

import TagDeleteRenderer from "./TagDeleteRenderer.js";
import TagEditRenderer from "./TagEditRenderer.jsx";
import TagTypeRenderer from "./TagTypeRenderer.jsx";

const TAGLIST_TABLE_COL_DEF = filter => [
  {
    field: "TagId",
    headerName: TAGLIST_TABLE_COLUMNS.tagId,
    defaultSort: "asc",
    editable: false,
    filter: filter
  },
  {
    field: "TagName",
    headerName: TAGLIST_TABLE_COLUMNS.tagName,
    flex: 1.5,
    editable: false,
    filter: filter
  },
  {
    field: "TagType",
    headerName: TAGLIST_TABLE_COLUMNS.tagType,
    width: 120,
    editable: false,
    filter: filter,
    cellRendererFramework: TagTypeRenderer
  },
  {
    field: "Description",
    headerName: TAGLIST_TABLE_COLUMNS.description,
    flex: 2,
    editable: false,
    filter: filter
  },
  {
    field: "Units",
    headerName: TAGLIST_TABLE_COLUMNS.units,
    flex: 1,
    editable: false,
    filter: filter
  },
  {
    field: "Value",
    headerName: TAGLIST_TABLE_COLUMNS.currentValue,
    editable: false,
    filter: filter,
    comparator: basicNumberComparator
  },
  {
    colId: "edit",
    lockPinned: true,
    pinned: "right",
    editable: false,
    width: 50,
    cellRendererFramework: TagEditRenderer
  },
  {
    colId: "delete",
    lockPinned: true,
    pinned: "right",
    editable: false,
    width: 50,
    cellRendererFramework: TagDeleteRenderer,
    cellStyle: params => {
      if (params.data && !params.data.IsDeletable) {
        return {
          backgroundColor: "var(--color-light-grey)",
          color: "var(--color-medium-grey)"
        };
      }
    }
  }
];

export const getTagListTableColDef = (filter, admin) =>
  TAGLIST_TABLE_COL_DEF(filter).map((colDef, idx) => {
    if (idx <= TAGLIST_TABLE_COL_DEF - 1) {
      colDef = { ...colDef, filter };
    }
    if (colDef["colId"] === "edit") {
      colDef = { ...colDef, hide: !admin, suppressToolPanel: !admin || colDef.suppressToolPanel || colDef.hide };
    }
    if (colDef["colId"] === "delete") {
      colDef = { ...colDef, hide: !admin, suppressToolPanel: !admin };
    }
    return colDef;
  });
